import React from "react";
import PropTypes from "prop-types";
import { Add } from "@mui/icons-material";
import { Typography } from "@mui/material";

import { UIButton, UIIcon } from "../../../../../ui";
import messages from "../../../../../../assets/locale/messages";
import { useSelector } from "react-redux";
import { clx } from "../../../../../../utils/Helpers";

const EmptyRolesState = ({ attentionKey, hasValidationError, onAddRole }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events?.creatEvent?.defineRolesAndShifts;

  return (
    <div
      className={clx("roles-empty-state", {
        "roles-empty-state--attention": hasValidationError,
      })}
      data-attention-key={attentionKey}
    >
      <div className="roles-empty-state__icon">
        <UIIcon
          name="personPlus"
          width={40}
          height={40}
          color="var(--color-primary-900)"
        />
        <span>
          <Add fontSize="small" />
        </span>
      </div>
      <Typography
        className="roles-empty-state__title text-heading-lg"
        component="h2"
      >
        {t.emptyTitle}
      </Typography>
      <Typography
        className="roles-empty-state__description text-body-md"
        component="p"
      >
        {t.emptyDescription}
      </Typography>
      <UIButton
        className={clx({
          "roles-empty-state__add--attention": hasValidationError,
        })}
        appearance="gradient"
        startIcon={<Add />}
        onClick={onAddRole}
        type="button"
      >
        {t.addFirstRole}
      </UIButton>
      <Typography
        className="roles-empty-state__note text-body-xxs"
        component="div"
      >
        {t.emptyNote}
      </Typography>
    </div>
  );
};

EmptyRolesState.propTypes = {
  attentionKey: PropTypes.number,
  hasValidationError: PropTypes.bool,
  onAddRole: PropTypes.func.isRequired,
};

EmptyRolesState.defaultProps = {
  attentionKey: 0,
  hasValidationError: false,
};

export default EmptyRolesState;
